import type { ThreadItem } from './types';

// Semantic constants of the AgentChat slice. Types live in types.ts,
// i18n in i18n.ts — anything not a type and not user-facing text belongs
// here.

/** Thread key for the not-yet-sent draft conversation. */
export const DRAFT_THREAD_KEY = '__draft__';

export const EMPTY_THREAD_ITEMS: ThreadItem[] = [];

/** Delay before the tour auto-starts after navigating to the flow's page:
 * the target page must mount its content first. If the steps still do not
 * match, the tour stays closed and the user can press Show me again. */
export const ONBOARDING_NAVIGATE_START_DELAY_MS = 1200;

/** Tour popover geometry (OnboardingTour). */
export const ONBOARDING_POPOVER_WIDTH = 320;
export const ONBOARDING_POPOVER_GAP = 12;
export const ONBOARDING_VIEWPORT_MARGIN = 12;
